// extracted by mini-css-extract-plugin
export default {"textbox":"Textbox__textbox___-I0FC"};